import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Dialog,
  TextField,
  Typography
} from '@material-ui/core';
import { Formik } from 'formik';
import * as yup from 'yup';
import NumberFormat from 'react-number-format';
import {
  updateCustomerGiftCardsBalanceApi,
  getCustomerGiftCardsBalanceApi,
  getCustomerGiftCardTransactionsApi
} from 'api';
import { BackdropCircular } from 'components';


const EditCustomerGiftCardBalance = ({
  openEditForm,
  setOpenEditForm,
  customerId
}) => {
  const dispatch = useDispatch();

  const {
    updatingGiftCardsBalance
  } = useSelector((state: IReduxState) => state.customers);

  const { profile } = useSelector((state: IReduxState) => state.user);

  const handleUpdateBalance = async (values) => {
    const isBalanceUpdated = await updateCustomerGiftCardsBalanceApi({
      dispatch,
      balance: values
    });

    if (isBalanceUpdated) {
      setOpenEditForm(false);
      getCustomerGiftCardsBalanceApi({dispatch, customerId});
      getCustomerGiftCardTransactionsApi({
        dispatch,
        customerId,
        sortDirection: 'desc',
        sortField: 'created_at',
        pageSize: '10',
        currentPage: '1'
      });
    }
  };

  return (
    <Dialog
      open={openEditForm}
      onClose={() => {
        setOpenEditForm(false);
      }}
      fullWidth
      maxWidth="sm"
    >
      <Formik
        initialValues={{
          customer_id: customerId,
          changed_by: `${profile.firstName} ${profile.lastName}`,
          amount: '',
          comment: ''
        }}
        validationSchema={yup.object({
          amount: yup.number().required('Field is required'),
          comment: yup.string().required('Field is required'),
        })}
        onSubmit={handleUpdateBalance}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue
        }) => (
          <form noValidate autoComplete="off" className="w-full" onSubmit={handleSubmit}>
            <Card elevation={20} className="p-7">
              <Typography variant="h4" className="h4 text-primary mb-5">
                Update Balance:
              </Typography>
              <NumberFormat
                customInput={TextField}
                fullWidth
                required
                fixedDecimalScale
                decimalScale={2}
                size="small"
                variant="outlined"
                name="amount"
                label="Amount"
                value={values.amount}
                onValueChange={(value) => {
                  setFieldValue('amount', value.floatValue);
                }}
                onBlur={handleBlur}
                error={touched?.amount && Boolean(errors?.amount)}
                helperText={
                  (touched?.amount && errors?.amount) ||
                      'Enter a positive number to add credit, or a negative number to subtract credit.'
                }
              />
              <TextField
                required
                fullWidth
                variant="outlined"
                label="Comment"
                name="comment"
                minRows="3"
                multiline
                className="my-5"
                value={values.comment}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.comment && Boolean(errors?.comment)}
                helperText={
                  (touched?.comment && errors?.comment) ||
                      'Describe the reason for the update to the Gift Card Credit Balance.'
                }
              />
              <div className="flex justify-end items-center w-full pt-5">
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpenEditForm(false)}
                  className="mr-4 w-full max-w-150"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="w-full max-w-150"
                >
                  Save
                </Button>
              </div>
            </Card>
          </form>
        )}
      </Formik>
      <BackdropCircular loading={updatingGiftCardsBalance} />
    </Dialog>
  );
};

export default EditCustomerGiftCardBalance;
